// Écran 002 « Classeur FTM ».
// Placeholder : la visualisation des FTM est en attente du modèle de données FTM
// (dates réception/rédaction, documents associés, confirmation OS, diffusion),
// absent du schéma. Voir docs/n134-visualiser-ftm.md.
export function FTMClasseur() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <h2 className="mb-4 text-xl font-semibold text-zinc-900 dark:text-zinc-100">
        Classeur FTM
      </h2>
      <div className="rounded-lg border border-zinc-200 bg-white p-6 text-center dark:border-zinc-700 dark:bg-zinc-900">
        <p className="text-sm text-zinc-500">
          La visualisation des FTM sera disponible une fois le modèle de données
          des Fiches Travaux Modificatifs en place.
        </p>
      </div>
    </div>
  );
}
